import 'twin.macro';
import { useAuth } from '@teetsh/app/src/containers/App/context/AuthContext';
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { routes as globalroutes } from '@teetsh/app/src/containers/routes';
import LoginPage from '@teetsh/app/src/containers/Auth/LoginPage';
import Maintenance from '@teetsh/app/src/containers/Maintenance/Loadable';
import ConfirmPage from '@teetsh/app/src/containers/Auth/ConfirmPage/Loadable';
import RequestResetPasswordPage from '@teetsh/app/src/containers/Auth/ResetPasswordPage/Request/Loadable';
import ResetPasswordPage from '@teetsh/app/src/containers/Auth/ResetPasswordPage/Reset/Loadable';
import { DemarrageRoutes } from '@teetsh/app/src/containers/Demarrage/routes';
import { Signup } from '@teetsh/app/src/containers/Signup2023';
import { useGlobalMessage } from '@teetsh/app/src/queries/globalMessage/useGlobalMessage';
import { GlobalMessageBanner } from '@teetsh/app/src/containers/GlobalMessage/GlobalMessageBanner';
import { useTranslation } from 'react-i18next';
import App from '@teetsh/app/src/App';
import { ErrorPage } from '@teetsh/app/src/components/ErrorPage';

export function Unauth() {
  const { i18n } = useTranslation();
  const auth = useAuth();
  const user = auth?.user;
  const { pathname, search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const isConfirmPage = pathname.endsWith('/confirm');
  const isDemarragePage = pathname.includes('/demarrage');
  const isInscriptionPage = /\/inscription\/?$/.test(pathname);
  const globalMessage = useGlobalMessage(i18n.language, {
    excludeIntents: ['marketing'],
    userPlan: undefined, // do not filter based on user plan here
  });

  if (user && isInscriptionPage) {
    return <Navigate to={{ pathname: '/demarrage', search }} />;
  }

  if (user && !isConfirmPage && !isInscriptionPage && !isDemarragePage) {
    const redirectTo = urlSearchParams.get('redirectTo');
    if (redirectTo) {
      const decodedRedirect = decodeURIComponent(redirectTo);
      // Split the redirect URL into pathname and search parts
      const [redirectPathname, redirectSearch] = decodedRedirect.split('?');
      return (
        <Navigate
          to={{
            pathname: redirectPathname,
            search: redirectSearch ? `?${redirectSearch}` : '',
          }}
        />
      );
    }
    return <Navigate to={{ pathname: '/dashboard', search }} />;
  }
  return (
    <>
      <GlobalMessageBanner globalMessage={globalMessage} />
      <Outlet />
    </>
  );
}

export const unauthRoutes = [
  {
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        element: <Unauth />,
        children: [
          {
            index: true,
            element: <Navigate to="/login" />,
          },
          {
            path: 'login',
            element: <LoginPage />,
          },
          { path: '/maintenance', element: <Maintenance /> },
          { path: '/confirm', element: <ConfirmPage /> },
          {
            path: globalroutes.onboarding,
            element: (
              <Navigate
                to={globalroutes.inscription + location.search}
                replace={true}
              />
            ),
          },
          { path: '/inscription', element: <Signup /> },
          { path: '/reset-password', element: <RequestResetPasswordPage /> },
          { path: '/change-password', element: <ResetPasswordPage /> },
          DemarrageRoutes,
        ],
      },
    ],
  },
];
